import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './Physicals.css';

const Physicals = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="physicals-container">
        <section className="physicals-hero">
          <h1>Physicals</h1>
          <p className="physicals-subtitle">
            Complete your healthcare information release authorization form
          </p>
        </section>
        
        <section className="physicals-content">
          <div className="container">
            <div className="office-form-container" style={{ width: '100%', maxWidth: '1000px', margin: '0 auto' }}>
              <iframe 
                title="Healthcare Information Release Authorization Form"
                width="100%"
                src="https://forms.office.com/Pages/ResponsePage.aspx?id=JvDATR8xuEKPc9pWetuIA152HT8sfctLv5FtWjZ0GVVUNEY4VERSTkpGT0NIN0c0WDQ4TVhDNkFJRy4u&embed=true" 
                frameBorder="0" 
                marginWidth="0" 
                marginHeight="0" 
                style={{ 
                  border: 'none',
                  maxWidth: '100%',
                  maxHeight: '2500px',
                  width: '100%',
                  height: '100%',
                  minHeight: '1200px'
                }} 
                allowFullScreen 
                webkitallowfullscreen 
                mozallowfullscreen 
                msallowfullscreen>
              </iframe>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Physicals;
